import { useMessage } from './useMessage'
import { UseQueryOptions } from 'react-query'
import { AIJobStatus } from 'types'
import { ChatMessage } from 'api/clients/ChatClient'

interface Props {
  threadId: number
  id: number
}

interface Options extends Omit<UseQueryOptions<{ message: ChatMessage }>, 'refetchInterval'> {
  intervalMs?: number
}

export const usePollMessage = ({ threadId, id }: Props, options?: Options) => {
  return useMessage(
    { threadId, id },
    {
      refetchInterval: (data) => {
        if (
          data?.message.status !== undefined &&
          [AIJobStatus.Successful, AIJobStatus.Failed, AIJobStatus.Expired].includes(data.message.status)
        ) {
          return false
        }

        return options?.intervalMs || 500
      },
      ...options,
    },
  )
}
